module.exports = __webpack_public_path__ + "img/getting_onto_platform.5c17a01b.jpg";